import React from "react";
import { formatAmount } from "../../utils/utils";

export const DashboardTableSchema = ({ operationPermissions, dashBoardTitle }) => {
    const defaultVisible = dashBoardTitle.slice(0, 6).map(d => d);
    const fields = dashBoardTitle.map((title, index) => {
        return {
            name: title,
            header: title.charAt(0).toUpperCase() + title.slice(1),
            visible: index < 6 ? true : false,
            type: "string",
            filtering: false,
            minWidth: 250,
            defaultFlex: 1,
            textAlign: "center",
            sortable: false,
            render: ({ data }) => (
                <span style={{ marginLeft: "-12px" }}>
                    {!isNaN(Number(data[title])) && data[title] !== ''
                        ? formatAmount({ amount: Math.round(Number(data[title])) })
                        : data[title]}
                </span>
            ),
        }
    });

    return {
        metadata: {
            title: "Dashboard",
            minHeight: 600,
            position: "relative",
            rowHeight: 60,
            showTitle: false,
            defaultSortInfo: { name: "status", dir: 1 },
            defaultVisible: [...defaultVisible],
        },
        fields: [
            ...fields
        ],
    }
}